<template>
  <div>
    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      controls
      indicators
      background="#ababab"
      img-width="1920"
      img-height="512"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <b-carousel-slide
        :caption="$gettext('Mario Viajes. Create your kind of holiday.')">
        <template v-slot:img>
          <img
            class="d-block w-100"
            width="1920"
            height="512"
            src="../../../../assets/images/mv/c-img-1.jpg"
            alt="image slot"
          >
        </template>
      </b-carousel-slide>
       <b-carousel-slide :caption="$gettext('Fabulous destinations are just a smile away!')">
        <template v-slot:img>
          <img
            class="d-block w-100"
            width="1920"
            height="512"
            src="../../../../assets/images/mv/c-img-2.jpg"
            alt="image slot"
          >
        </template>
      </b-carousel-slide>
       <b-carousel-slide :caption="$gettext('Relax… You’re with us! We make it simple.') ">
        <template v-slot:img>
          <img
            class="d-block w-100"
            width="1920"
            height="512"
            src="../../../../assets/images/mv/c-img-3.jpg"
            alt="image slot"
          >
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<style>
  .carousel-caption {
    position: absolute;
    right: 15%;
    bottom: 50%;
    left: 15%;
    z-index: 10;
    padding-top: 20px;
    padding-bottom: 20px;
    color: #fff;
    text-align: center;
    transform: translateY(50px);
  }
  .carousel-caption h3{
    font-size:3em;
  }
</style>

<script>
export default {
  name: 'Carousel',
  data () {
    return {
      slide: 0,
      sliding: null
    }
  },
  methods: {
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = false
    }
  }
}
</script>
